<!--
 * @Author: DXG
 * @Date: 2024-04-25 17:39:49
 * @LastEditors: DXG
 * @LastEditTime: 2024-04-26 08:23:46
 * @FilePath: \kdtup-pc-web\src\bizcomponents\fund\buyFund.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<!--
Author: TangChen
Date: 2018-12-8
Desc: 购买基金，由index.js 配置引入
-->
<template>
    <div>
        <div :class="'bizcomp-buy-fund bizcomp ' + className">
            <comp-title-dc :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/fund' }">基金交易</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title-dc>
            <!--购买逻辑全在该组件内-->
            <buy-comp ref="buyComp" />
        </div>
        <footerQuestions
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import buyComp from "@/components/fund/buyCompDC";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "BuyFund",
    components: {
        buyComp,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            commonQuestion: [], // 常见问题
            warningHtml: "" // 温馨提示
        };
    },
    mounted() {
        setTimeout(() => {
            this.assignTipAndQuestion();
        }, 1000);
    },
    methods: {
        // 赋值温馨提示和常见问题
        assignTipAndQuestion() {
            this.commonQuestion = [
                {
                    title: "1.什么是基金认购？认购后基金封闭期多长？",
                    answer: "基金认购是指在开放式基金募集期间、基金尚未成立时购买基金份额的过程。基金封闭期自基金成立日起最长不超过3个月(即最长3个月)，如果提前打开申购或赎回，公司会提前2日在公司网站或相关媒体上公告。",
                    showFlag: false
                },
                {
                    title: "2.申购和认购有什么区别？",
                    answer: "基金首次募集期购买基金的行为称为认购；在基金成立后购买基金的行为称为申购；一般情况下，认购期购买基金的费率相对来说要比申购期购买优惠。认购期购买的基金一般要经过封闭期才能赎回，申购的基金要在申购成功后的第二个工作日才能进行赎回。",
                    showFlag: false
                },
                {
                    title: "3.认购可以撤单吗？",
                    answer: "认购申请一经受理，不得撤销。投资者在募集期内可多次认购基金份额，其认购金额按照单笔认购金额对应的费率为基准进行计算。",
                    showFlag: false
                },
                {
                    title: "4.认购持有期是从什么时候开始算起的？认购冻结金额有利息吗？",
                    answer: "认购的基金持有期限从基金成立日开始算(例如：10月1日认购的新基金，假设基金于11月1日成立，则到12月1日，持有时间为31天)。认购期冻结资金会按原认购金额(不扣除认购费)计算利息，会折算成基金份额计入客户基金账户。",
                    showFlag: false
                },
                {
                    title: "5.我认购的基金为什么查不到份额？",
                    answer: "您认购的基金目前正处于验资期，验资结束后我司会公告基金成立，届时即可查询到份额确认情况。",
                    showFlag: false
                },
                {
                    title: "6.当投资者办理“认购”业务时，选择资金来源为 “大成钱柜”，办理的是什么业务？",
                    answer: "办理的是大成钱柜下的大成添利宝E(000726)向所认购基金的赎回转认购业务。",
                    showFlag: false
                },
                {
                    title: "7.什么是七日年化收益率和日每万份收益？",
                    answer: "日每万份收益是指每万份基金单位当日净收益。日每万份基金净收益＝当日基金净收益/当日基金份额总额×10000。七日年化收益率是指货币基金最近连续7个自然日每万份基金份额净收益折合成的年收益率，代表过去的收益情况，仅供参考。招财宝基金收益分配方式是每日分配、按日支付。收益是T+2个工作日起可以赎回。当您在今日赎回时，昨日的收益需要下个工作日才可以赎回。",
                    showFlag: false
                },
                {
                    title: "8.大成旗下的基金产品在法定节假日期间是否暂停申购？",
                    answer: "有些基金在法定节假日期间确实会暂停申购，具体情况请您提前关注我们的公司公告，提前做好交易安排，以免造成不便。",
                    showFlag: false
                }
            ];
            this.warningHtml = `1.钱柜买基金”实质为基金转换交易(适用于已开通转换业务的基金)或赎回转认/申购交易(适用于未开通转换业务的基金)等业务。通过“钱柜买基金”功能，可享手续费率优惠。最低10元起购。<br>2.${this.$const.COMPANY}基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。`;
        }
    }
};
</script>
